import { RowSeatFragment } from '@websky/graphql';

export function isSeatAvailableAndExistent(seat: RowSeatFragment): boolean {
	return seat.isAvailable && seat.isExistent && !seat.isAisle;
}
